<template>
  <div class="user-profile">
    <div class="loader" v-if="!loaded">
      <div>
        <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
      </div>
    </div>
    <headerComponent></headerComponent>
    <div class="container position-relative mb-3">
      <div class="row">
        <div class="col-lg-4 col-12">
          <sidebarComponent></sidebarComponent>
        </div>
        <div class="col-lg-8 col-12">
          <form @submit.prevent="saveData()">
            <div class="row">
              <div class="col-12 d-flex justify-content-between align-items-start">
                <h2>User data</h2>
                <div>
                  <!--button class="buttons button-one m-1" v-if="isUser" @click="deleteUser">Remove</button-->
                  <router-link to="/users-management" class="buttons button-two m-1" v-if="isUser">Back</router-link>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-lg-6 col-12 mb-2" :class="{'col-xl-3':!isUser}">
                <label>Name</label>
                <input type="text" v-model="user.general_name" class="form-control" required>
              </div>
              <div class="form-group col-lg-6 col-12 mb-2" :class="{'col-xl-3':!isUser}">
                <label>Surname</label>
                <input type="text" v-model="user.general_surname" class="form-control" required>
              </div>
              <div class="form-group col-lg-6 col-12 mb-2" :class="{'col-xl-3':!isUser}">
                <label>Email</label>
                <input type="text" v-model="user.general_email" class="form-control" required>
              </div>
              <div class="form-group col-lg-6 col-12 mb-2" :class="{'col-xl-3':!isUser}">
                <label>Password</label>
                <input type="text" v-model="user.general_password" class="form-control" required v-if="isNew">
                <input type="text" v-model="user.general_password" class="form-control" v-else>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12">
                <button class="buttons button-one">Save data</button>
              </div>
            </div>
          </form>
        </div>
      </div>

    </div>
    <footerComponent></footerComponent>
  </div>
</template>

<script>
import footerComponent from '../components/Footer.vue'
import headerComponent from '../components/Header.vue'
import sidebarComponent from '../components/Sidebar.vue'
import commonProps from '../common/common.js'
import axios from 'axios'
import '@/assets/scss/profile.scss';
const common = new commonProps;
export default {
  name:'user-profile',
  components: {
    headerComponent,
    sidebarComponent,
    footerComponent
  },
  data() {
    return {
      user:{},
      isNew:true,
      isUser:false,
      loaded:false
    }
  },
  mounted() {
    //console.log(this.$route.name)
    if (this.$route.name == 'user-edit' || this.$route.name == 'user-new') {
      this.isUser = true
      this.loaded = true
    }
    if (this.$route.params.user_id) {
      this.getUser(this.$route.params.user_id)
      this.isNew = false;
    }
    if (this.$route.name == 'user-profile') {
      this.isNew = false;
      this.getProfile();
    }
    
  },
  methods: {
    getUser(id) {
      axios .get(`${common.supervisorApi}users/get_user_by_id/${id}`)
            .then(result => {
              this.loaded = true
              if (result.data)
                this.user = result.data
            })
    },
    getProfile() {
      axios .get(`${common.supervisorApi}users/get_profile`)
            .then(result => {
              //console.log(result.data)
              if (result.data)
                this.user = result.data.data
            })
    },
    saveData() {
      if (this.isUser)
        this.saveSimpleUserData()
      else
        this.saveMainProfileData()
    },
    saveSimpleUserData() {
      //console.log(this.user)
      axios .post(`${common.supervisorApi}users/update_user_data/1`, this.user)
            .then(result => {
              if (result.data && !result.data.error)
                this.$swal.fire('Success', 'User created', 'success');
            })
    },
    saveMainProfileData() {
      axios .post(`${common.supervisorApi}users/update_user_data`, this.user)
            .then(() => {
              /*if (result.data && !result.data.error)
                //console.log(result.data)
                /*this.$swal.fire({
                  icon:'success',
                  text:`Operation successfully done`,
                  timer:1500,
                  showConfirmButton:false
                }).then(() => {
                  this.$router.push('/users-management')
                })*/
            })
    },
    /*deleteUser() {
      console.log(this.user)
    }*/
  }
}
</script>

